<template>
  <div class="container-fluid">
    <div class="row">
      <div v-if="can('payment_list')" class="col-12">
        <div class="d_flex_btwn">
          <h5 class="common_subtitle pb_20  font_16p pt_20">Payments </h5>
        </div>

        <cloud-table-component
            :columns="columns"
            :rows="inquiries"
            :sortable="sortable"
            :pagination="pagination"
            @sorting="sorting"
            @pageChanged="pageChanged">

          <template v-slot:status="{ row }">
            <span v-if="row.status === 'processing'" class="color_warning">Processing</span>
            <span v-if="row.status === 'running'" class="color_success">Running</span>
            <span v-if="row.status === 'stopped'" class="color_danger">Stopped</span>
          </template>
          <template v-slot:total_amount="{ row }">
            <div>{{ formatPrice(row.total_amount) }}</div>
          </template>
          <template v-slot:action="{ row }">
            <router-link v-if="can('view_payment')" :to="{name: 'billing_invoice', params: {id: row.id, date: row.billing_date}}" type="button" class="btn btn-outline-primary btn-sm mr_15 width_100p" @click.prevent="openDetailsInquiry(row.id)">
              Details
            </router-link>
          </template>
        </cloud-table-component>
      </div>
      <div v-else>
        <p>You do not have permission to view this content.</p>
      </div>
    </div>
  </div>
</template>

<script>
import CloudTableComponent from "@/components/shared/CloudTableComponent.vue";
import { useAbility } from '@casl/vue';
import {mapGetters} from "vuex";

export default {
  name: "Payment",
  components: {CloudTableComponent},
  setup() {
    const { can } = useAbility();

    return {
      can
    };
  },
  data() {
    return {
      inquiries: [],
      filter: {
        server_region_id: '',
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'cloudService.name,cloudServer.server_name,status',
        sort: 'billing_month',
        sort_order: 'desc',
        per_page: 10
      },
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: "Service",
          field: "cloud_service.name",
        },
        {
          label: "Server Name",
          field: "cloudServerPrice.cloud_server.host_name",
        },
        {
          label: "Service Type",
          field: "service_type",
          sortable: true,
        },
        {
          label: "Billing Type",
          field: "billing_type",
          sortable: true,
        },
        {
          label: "Amount",
          field: "total_amount",
          sortable: false,
          slot: true,
        },
        {
          label: "Billing Month",
          field: "billing_date",
          sortable: true,
        },
        {
          label: "Status",
          field: "status",
          sortable: true,
        },
        {
          label: "Action",
          field: "action",
          sortable: false,
          slot: true,
        },
      ],
      pagination: null,
      isShowInquiryModal: false,
      editId: null,
      isShowInquiryDetailsModal: false,
      inquiryId: null,
    }
  },
  watch: {
    '$route.query.page': {
      handler(newSlug, oldSlug) {
        if (newSlug !== oldSlug) {
          this.setQueryData(this.getAllQueryParams());
          this.loadData();
        }
      },
    },
    customer() {
      this.loadData();
    }
  },
  computed: {
    ...mapGetters({
      customer: 'auth/getUserInfo',
    }),
    title(){
      if (this.editId) {
        return 'Add New Ticket';
      } else {
        return 'Edit Ticket';
      }
    }
  },
  mounted() {
    const query = this.getAllQueryParams()
    if (query.page) {
      this.setQueryData(query)
    }
    this.loadData()
  },
  methods: {
    setQueryData(query) {
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {
        server_region_id: query.server_region_id,
      }

      this.sortable = {
        order: query.sort,
        sort: query.sort_order
      }
    },
    resetAll() {
      this.sortable = {
        order: 'billing_month',
        sort: 'desc'
      }

      this.filter = {
        server_region_id: '',
      }

      this.queryParams = {
        page: 1,
        search: '',
        search_columns: 'cloudService.name,cloudServer.server_name,status',
        sort: 'billing_month',
        sort_order: 'desc',
        per_page: 10
      }

      this.changeRoute();
      this.loadData();
    },
    searchQuery() {
      this.changeRoute();
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute()
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute()
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    loadData() {
      this.lyLoading = true
      let params = { ...this.queryParams, ...this.filter }
      this.axios.get('/generated-payments', {
        params : params
      })
          .then(({data}) => {
            this.inquiries = data.data
            this.pagination = data.meta;
          })
          .finally(() => {
            this.lyLoading = false;
          })
    },
    openDetailsInquiry(inquiryId){
      this.inquiryId = inquiryId
      this.isShowInquiryDetailsModal = true
    },
    closeDetailsInquiry(){
      this.inquiryId = null
      this.isShowInquiryDetailsModal = false
    },
  }
}
</script>

<style scoped>

</style>